<template>
  <v-menu
    v-model="menuContainer"
    :class="{ 'v-menu__activator--disabled': !isSuccess }"
    :close-on-content-click="false"
    :open-on-click="false"
    offset-y
  >
    <v-btn
      slot="activator"
      :disabled="!isSuccess"
      flat
      @click="toggleDropdown"
    >
      <span class="toolbar__button-label">
        <span v-if="selectedStatus" class="autocomplete__text autocomplete__text--active">{{ selectedStatus }}</span>
        <span v-else class="autocomplete__text">{{ $t('Common.by') }} status</span>
      </span>
      <v-icon right small v-if="!isSelected">keyboard_arrow_down</v-icon>
      <v-icon right small color="accent" v-if="isSelected" id="menu-item__clear" @click="toggleDropdown">close</v-icon>
    </v-btn>

    <v-list class="v-list--custom">
      <v-list-tile
        v-for="status in items"
        :key="status.value"
        @click="getSelectedStatus(status)"
      >
        <v-list-tile-title>{{ status.text }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'MenuItemStatus',
  props: {
    filters: Object,
    type: String,
    items: {
      type: Array,
      require: true
    },
    status: {
      type: Number,
      default: STATUS_SUCCESS
    }
  },
  data () {
    return {
      menuContainer: false,
      selectedStatus: null,
      isSelected: false
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  methods: {
    resetProps () {
      this.updateFilters()
      this.menuContainer = false
      this.isSelected = false
      this.selectedStatus = null
    },

    toggleDropdown ($event) {
      if ($event.target.id === 'menu-item__clear') {
        this.resetProps()
        return
      }
      this.menuContainer = true
    },

    updateFilters (status = null) {
      this.$emit('change', { status })
    },

    getSelectedStatus ({ value, text }) {
      this.updateFilters(value)
      this.menuContainer = false
      this.isSelected = true
      this.selectedStatus = text
    }
  }
}
</script>
